<agm-map #map [latitude]="mapCenter.lat" [longitude]="mapCenter.lng" [zoom]="originalMapZoom" [mapTypeId]="'hybrid'"
  (mapReady)="onMapReady($event)">
  <agm-polygon *ngFor="let areaPolygon of areaPolygons; let i = index" [paths]="areaPolygon.coordinates"
    [editable]="areaPolygonOptions.editable" [fillColor]="areaPolygonOptions.fillColor"
    [strokeColor]="areaPolygonOptions.strokeColor" [polyDraggable]="areaPolygonOptions.draggable"
    [strokeWeight]="areaPolygonOptions.strokeWeight" [fillOpacity]="areaPolygonOptions.fillOpacity"
    [strokeOpacity]="areaPolygonOptions.strokeOpacity" [zIndex]="areaPolygonOptions.zIndex" [clickable]="!isDrawing">
    <agm-marker [latitude]="areaPolygon.locationPoint.lat" [longitude]="areaPolygon.locationPoint.lng"
      [title]="buildAreaTitle(areaPolygon.name, areaPolygon.hectares)"
      [iconUrl]="'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'"
      (markerClick)="onAreaMarkerClick(infoWindow, map)">
    </agm-marker>
    <agm-info-window [disableAutoPan]="false" [latitude]="areaPolygon.locationPoint.lat"
      [longitude]="areaPolygon.locationPoint.lng" #infoWindow>
      <div style="width: 450px;">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label>Sucursal</label>
            <input type="text" class="form-control" name="fieldName" [(ngModel)]="areaPolygon.name" readonly>
          </div>
          <div class="form-group col-md-3">
            <label>Ha totales</label>
            <input type="text" class="form-control" name="fieldName" [(ngModel)]="areaPolygon.hectares" readonly>
          </div>
          <div class="form-group col-md-3">
            <label>Ha laborables</label>
            <input type="text" class="form-control" name="fieldName" [(ngModel)]="areaPolygon.arableHectares" readonly>
          </div>
          <div class="form-group col-md-2">
            <label>Porcentaje</label>
            <button type="button" class="btn btn-sm btn-warning ml-1"
              (click)="showPercentage(areaPolygon.id)">{{areaPolygon.markedPercentage}}</button>
          </div>
        </div>
        <div class="form-row" [hidden]="!showAreaDetail">
          <div *ngFor="let detail of areaPolygon.details" class="classification-status" [ngClass]="{
            'green':detail.id===1,
            'yellow':detail.id===2,
            'red':detail.id===3,
            'burgundy':detail.id===4,
            'gray':detail.id===100,
            'col-md-1':(detail.percentage<=10),
            'col-md-2':(detail.percentage>10&&detail.percentage<=22),
            'col-md-3':(detail.percentage>22&&detail.percentage<=32),
            'col-md-4':(detail.percentage>32&&detail.percentage<=42),
            'col-md-5':(detail.percentage>42&&detail.percentage<=52),
            'col-md-6':(detail.percentage>52&&detail.percentage<=62),
            'col-md-7':(detail.percentage>62&&detail.percentage<=72),
            'col-md-8':(detail.percentage>72&&detail.percentage<=82),
            'col-md-9':detail.percentage>82
            }"><strong> {{detail.percentage}}%</strong></div>
        </div>
      </div>
    </agm-info-window>
  </agm-polygon>
  <agm-marker [latitude]="cotagroLatLng.lat" [longitude]="cotagroLatLng.lng"
    [title]="'COTAGRO - Cantidad total de hectáreas: ' + cotagroHa"
    [iconUrl]="'https://maps.google.com/mapfiles/ms/icons/green-dot.png'"
    (markerClick)="onAreaMarkerClick(infoWindow, map)">
  </agm-marker>
  <agm-info-window [disableAutoPan]="false" [latitude]="cotagroLatLng.lat" [longitude]="cotagroLatLng.lng" #infoWindow>
    <div style="width: 450px;">
      <div class="form-row">
        <div class="form-group col-md-7">
          <label>Cotagro</label>
          <input type="text" class="form-control" name="fieldName" value="COTAGRO" readonly>
        </div>
        <div class="form-group col-md-3">
          <label>Hectáreas totales</label>
          <input type="text" class="form-control" name="fieldName" value="1418653" readonly>
        </div>
        <div class="form-group col-md-3">
          <label>Marcado</label>
          <input type="text" class="form-control" name="fieldName" value="1418653" readonly>
        </div>
      </div>
    </div>
  </agm-info-window>
  <agm-info-window *ngIf="isPopupFieldOpen" [disableAutoPan]="false" [isOpen]="isPopupFieldOpen"
    [latitude]="popupCenter.lat" [maxWidth]="'650'" [longitude]="popupCenter.lng"
    (infoWindowClose)="closeFieldPopup({cancelAction:true})">
    <app-field *ngIf="isPopupFieldOpen" [polygon]="selectedPolygon" (closeAction)="closeFieldPopup($event)"></app-field>
  </agm-info-window>
</agm-map>